<template>
  <div
    class="form-counter"
    :class="{
      grayed,
      error,
    }"
  >
    <input
      type="number"
      class="counter-input"
      :value="modelValue"
      :placeholder="placeholder"
      @input="onInput"
      aria-label="value"
    />

    <div class="counter-arrows">
      <div
        class="top-arrow"
        @click="increment"
        @keypress.enter="increment"
        @mouseenter="topArrowHovered = true"
        @focus="topArrowHovered = true"
        @mouseleave="topArrowHovered = false"
        @blur="topArrowHovered = false"
      >
        <inline-svg
          :src="$assets.svg['arrowIcon']"
          class="svg-wrapper"
          width="10px"
          height="10px"
          fill="none"
          :stroke="topArrowStroke"
        />
      </div>
      <div
        class="bottom-arrow"
        @click="decrement"
        @keypress.enter="decrement"
        @mouseenter="bottomArrowHovered = true"
        @focus="bottomArrowHovered = true"
        @mouseleave="bottomArrowHovered = false"
        @blur="bottomArrowHovered = false"
      >
        <inline-svg
          :src="$assets.svg['arrowIcon']"
          class="svg-wrapper"
          width="10px"
          height="10px"
          fill="none"
          :stroke="bottomArrowStroke"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';

import $assets from '@/assets';

const emit = defineEmits(['update:modelValue']);
const props = defineProps({
  placeholder: {
    type: String,
    default: null,
  },
  showPlaceholder: {
    type: Boolean,
    default: true,
  },
  modelValue: {
    type: Number,
    default: 0,
  },
  error: {
    type: Boolean,
    default: false,
  },
  grayed: {
    type: Boolean,
    default: false,
  },
});

const topArrowHovered = ref(false);
const bottomArrowHovered = ref(false);

const topArrowStroke = computed(() => {
  if (topArrowHovered.value) {
    return 'rgb(100, 148, 37)';
  }

  if (props.grayed) {
    return '#555555';
  }

  return '#000000';
});

const bottomArrowStroke = computed(() => {
  if (bottomArrowHovered.value) {
    return 'rgb(100, 148, 37)';
  }

  if (props.grayed) {
    return '#555555';
  }

  return '#000000';
});

function onInput(event) {
  emit('update:modelValue', event.target.value);
}

// these increase/decrease the 'value', which will convert to 0 automatically when calculated
function increment() {
  emit('update:modelValue', props.modelValue + 1);
}

function decrement() {
  emit('update:modelValue', props.modelValue - 1);
}
</script>

<style scoped>
.form-counter {
  position: relative;
  height: auto;
  /* width set by parent component */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

.counter-input {
  background: white;
  height: 100%;
  width: 100%;
  appearance: textfield;
  box-sizing: border-box;
  padding: 4px 10px 4px 7px;
  border: 1px solid #6d6e71;
  border-radius: 7px;
  transition: all 0.3s;
  white-space: nowrap;
  font-size: 16px;
  color: #6d6e71;
}
.counter-input::-webkit-inner-spin-button,
.counter-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
}

.form-counter.grayed .counter-input {
  border-color: #a7a9ac;
  color: #a7a9ac;
}
.form-counter.error .counter-input {
  background-color: rgb(255, 207, 207);
}

.form-counter::placeholder {
  color: #acaca6;
}

.counter-arrows {
  position: absolute;
  right: 10px;
  top: unset;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.top-arrow,
.bottom-arrow {
  cursor: pointer;
  height: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.top-arrow {
  transform: rotate(180deg);
}

.svg-wrapper {
  pointer-events: none;
}
</style>
